<template>
  <div class="gobuy">
    <gobuy-head :title="$t('Language selection')" />
    <div class="zhanweifu" style="height: 4.2rem;" v-if="!$IFR.is_iframe"></div>

    <body>
      <div style="padding-bottom: 1px">
        <div class="list_box">
          <div class="list">
            <div
              class="item ds-button"
              v-for="(item, index) in list"
              :key="index"
              @click="change_lang(item.en)"
            >
              <div class="icon">
                <img :src="getFlagUrl(item.flag)"/>
              </div>
              <div class="text">{{ utils.languageMap(item.en) }}</div>
            </div>
          </div>
        </div>
      </div>
    </body>
  </div>
</template>

<script>
import { Toast, MessageBox, Indicator } from "mint-ui";
import { getLangList, change_lang } from "../../../api/homeindex";

export default {
  components: {},
  data() {
    return {
      list: [],
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getLangList();
    window.scrollTo(0, 0);
  },
  methods: {
    getFlagUrl(flag) {
      return require(`@/assets/image/flag/${flag}.png`);
    },
    change_lang(lang) {
      if (this.utils.fetch("lang") == lang) return;
      // 本地存储
      this.$i18n.locale = lang
      this.utils.save("lang", lang)
      this.utils.save("locale", lang)

      change_lang(lang).then((res) => {
        if (res.code == 10000) {
          Toast(res.message);
          setTimeout(() => {
            this.$router.go(-1);
          }, 500);
        }
      });
    },
    getLangList() {
      getLangList().then((res) => {
        this.list = res.result;
      });
    },
    // iconFun(en) {
    //   if (en == "enus") return "en";
    //   if (en == "Thai") return "tai";
    //   if (en == "Jap") return "jap";
    //   if (en == "Korean") return "kr";
    //   // if (en == "Vietnamese") return "vit";
    //   // if (en == "Indonesia") return "bah";
    //   if (en == "French") return "fra";
    //   if (en == "German") return "deu";
    //   if (en == "TW") return "TW";
    // },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}

.gobuy {
  width: 100%;
  .logo {
    position: fixed;
    top: 25px;
    left: 12px;
    z-index: 99;

    img {
      width: 3.5rem;
    }
  }
  body {
    width: 100%;
    background-color: transparent;
    top: 100px;
    height: 100vh;
  }
  .common-header-wrap {
    position: fixed;
    top: 54px;
    width: 100%;
    .common-header {
      background-color: rgba(232, 9, 12, 0.6);
      color: #fff;
      box-shadow: none;
    }
  }
  .list_box {
    padding: 12px;

    .list {
      background: url("../../../assets/image/go3.png") no-repeat;
      background-size: 100% 100%;
      padding: 25px 12px;
      .item {
        background: #FFF1F1;
        border-radius: 15px 15px 15px 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0 20px 0;
        padding: 12px 0;
        text-align: center;

        &:nth-last-child(1) {
          margin-bottom: 0;
        }

        .icon {
          width: 52px;
          height: 32px;

          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }

        .text {
          width: 6rem;
          margin-left: 15px;
          font-size: 20px;
        }
      }
      .item:active {
        background-color: #FFC3C1 !important;
      }
    }
  }
}
</style>
